import { gql } from '@apollo/client';

import { TShopGood } from 'types';

export interface IGoodsRequest {
  input: {
    client_uuid?: string;
  };
}
export interface IGoodsResponse {
  goods: Array<TShopGood>;
}
export const GOODS = gql`
  query goods($input: GoodsInput!) {
    goods(input: $input) {
      id
      title
      cost
      amount
      use_global_discounts
      use_fair_sign
      vat
      tax_system
      is_excise
      available_to_buy
      category {
        id
        company_id
        title
        show_in_shell
      }
    }
  }
`;
